import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-update",
  "use": "icon-update-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-update\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 128l64 64-384 384-96 32 32-96 384-384z\" p-id=\"2140\" /><path d=\"M832 831.89l-0.11 0.11H192.11l-0.11-0.11V192.11l0.11-0.11H704v-64H192a64.19 64.19 0 0 0-64 64v640a64.19 64.19 0 0 0 64 64h640a64.19 64.19 0 0 0 64-64V320h-64z\" p-id=\"2141\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol